export const cldrJsonDataDE = [require("./cldr-data/de")];
